export default __webpack_public_path__ + "static/media/calc.b29495ee.svg";